import { render } from "./WidgetsSkeleton.vue?vue&type=template&id=392ba028"
import script from "./WidgetsSkeleton.vue?vue&type=script&lang=js"
export * from "./WidgetsSkeleton.vue?vue&type=script&lang=js"
script.render = render

export default script